import { useRef } from 'react';
import { useSelector } from 'react-redux';

import { Card } from 'modules/experiments/components/ui';
import { VariantBreakdownCardProps } from 'modules/experiments/types';
import { MONITOR_CARD_HEIGHT } from 'modules/experiments/constants';
import { getExperimentLoadingState } from 'modules/experiments/ducks/selectors';
import { CardHeader } from './Header';
import { PerformanceBodyWrapper } from './Styled';
import { TimeSeriesChart } from './Chart';

export const VariantPerformance = ({
  options,
  metricMap,
  variantList,
}: VariantBreakdownCardProps) => {
  const chartRef = useRef();
  const loading = useSelector(getExperimentLoadingState);

  return (
    <Card
      testId="variant-performance"
      cardHeader={<CardHeader loading={loading} chartRef={chartRef} options={options} />}
      loading={loading}
      height={MONITOR_CARD_HEIGHT.VARIANT_PERFORMANCE}
    >
      <PerformanceBodyWrapper data-test="variant-performance-chart-section">
        <TimeSeriesChart
          options={options}
          metricMap={metricMap}
          variantList={variantList}
          chartRef={chartRef}
        />
      </PerformanceBodyWrapper>
    </Card>
  );
};
